import angular from "angular";
import panel from "../services";

function isValidPassword(panel) {

    return (scope, element) => {

        panel.registerEvent('is-valid-password-error', (e) => {
            let el = $('.register-'+e.detail.item);
            el.siblings('div.error').html('');
            if (is_string(e.detail.message)) {
              el.siblings('div.error').append('<div>' + e.detail.message + '</div>');
            } else {
              for (let i in e.detail.message) {
                el.siblings('div.error').append('<div>' + e.detail.message[i] + '</div>');
              }
            }
        });

        $(element).keyup((e) => {

            let errors = [];
            let el = $(e.target);
            let value = el.val();
            let char_length = 8;

            if (value.trim() === '') return;

            if (value.length < char_length) errors.push('Minimum '+char_length+' characters.');

            if (!(/\d/g).test(value)) errors.push('Must contain at least 1 digit.');

            if (((/[a-z]/g).test(value) && (/[A-Z]/g).test(value)) === false) errors.push('Must have a both upper and lowercase letters.');

            if (!(/[!-\/:-@[-`{-~]/g).test(value)) errors.push('Must contain at least 1 special char.');

            el.siblings('div.error').html('');

            if (errors.length !== 0) {
                for (let i in errors) {
                    el.siblings('div.error').append('<div>'+errors[i]+'</div>');
                }
            }
        });
    }
}

export default angular.module('directives.isValidPassword', [panel]).directive('isValidPassword', isValidPassword).name;



// WEBPACK FOOTER //
// ./src/app/directives/isValidPassword.js